import React from 'react'
import Route from 'react-router/lib/Route'
import IndexRoute from 'react-router/lib/IndexRoute'

import App from 'containers/App'
import Login from 'containers/Auth/Login'
import Logout from 'containers/Auth/Logout'

import Admin from 'containers/Admin'
import Account from 'containers/Account'

import Payments from 'containers/Payments'
import PaymentsDefault from 'containers/Payments/default'
import PaymentsNew from 'containers/Payments/new'
import PaymentsShow from 'containers/Payments/show'

import NotePayments from  'containers/NotePayments'
import NotePaymentsNew from 'containers/NotePayments/new'
import NotePaymentsDefault from 'containers/NotePayments/default'
import NotePaymentsShow from 'containers/NotePayments/show'

import Ledger from 'containers/Ledger'
import LedgerDefault from 'containers/Ledger/default'
import LedgerShow from 'containers/Ledger/show'

import Print from 'containers/Print'
import PrintReceipt from 'containers/Print/Receipt'
import PrintCollections from 'containers/Print/Reports/Collections'

import ReportCollections from 'containers/Reports/Collections'

import FeesPresets from 'containers/FeesPresets'
import FeesPresetsDefault from 'containers/FeesPresets/default'
import FeesPresetsShow from 'containers/FeesPresets/show'

import auth from 'containers/Admin/authentication'

export default function createRoutes(store) {
  return (
    <Route component={App}>
      <Route path="login" component={Login} />
      <Route path="logout" component={Logout} onEnter={Logout.onEnter(store)} />
      <Route path="/" component={Admin} onEnter={auth(store)}>
        <Route path="account" component={Account} />
        <Route path="payments" component={Payments} onEnter={Payments.onEnter(store)}>
          <IndexRoute component={PaymentsDefault} />
          <Route path="new" component={PaymentsNew} />
          <Route path=":id" component={PaymentsShow} onEnter={PaymentsShow.onEnter(store)} />
        </Route>
        <Route path="/notepayments" component={NotePayments}>
          <IndexRoute component={NotePaymentsDefault} />
          <Route path="new" component={NotePaymentsNew} />
          <Route path=":id" component={NotePaymentsShow} onEnter={NotePaymentsShow.onEnter(store)} />
        </Route>
        <Route path="ledger" component={Ledger}>
          <IndexRoute component={LedgerDefault} />
          <Route path=":studentID" component={LedgerShow} onEnter={LedgerShow.onEnter(store)} />
        </Route>
        <Route path="reports/collections" component={ReportCollections} />
        <Route path="fees-presets" component={FeesPresets} onEnter={FeesPresets.onEnter(store)}>
          <IndexRoute component={FeesPresetsDefault} />
          <Route path=":id" component={FeesPresetsShow} />
        </Route>
      </Route>
      <Route path="print" component={Print} onEnter={auth(store)}>
        <Route path="receipt/:collectionID" component={PrintReceipt} />
        <Route path="reports/collections" component={PrintCollections} />
      </Route>
    </Route>
  )
}



// WEBPACK FOOTER //
// ./src/routes.js